import React, { useEffect, useState } from "react";
import NoDataFound from "../common/NoDataFound";
import { loadStyles } from "../../utils/cssLoader";

const BasketballLineup = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const [activeTeam, setActiveTeam] = useState("home");

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("basketballlineup");
    }
  }, [loadCSS]);

  const lineupData = dataClient ? clientData : data;

  if (!lineupData) {
    return <NoDataFound />;
  }

  const homeTeamLineup = lineupData?.home_team?.lineup || [];
  const awayTeamLineup = lineupData?.away_team?.lineup || [];
  const homeTeamName = lineupData?.home_team?.nm || "Home";
  const awayTeamName = lineupData?.away_team?.nm || "Away";

  const currentLineup = activeTeam === "home" ? homeTeamLineup : awayTeamLineup;

  return (
    <div className="basketball_lineup_container">
      {title && <h1>{title}</h1>}

      <div className="lineupbox">
        <nav className="inner_tab">
          <ul>
            <li
              className={activeTeam === "home" ? "active" : ""}
              onClick={() => setActiveTeam("home")}
            >
              <a href="#">{homeTeamName}</a>
            </li>
            <li
              className={activeTeam === "away" ? "active" : ""}
              onClick={() => setActiveTeam("away")}
            >
              <a href="#">{awayTeamName}</a>
            </li>
          </ul>
        </nav>

        {currentLineup.length > 0 ? (
          <div className="global_table player_lineup">
            <table>
              <thead>
                <tr>
                  <th>Players</th>
                  <th>OR</th>
                  <th>SNO</th>
                  <th>POS</th>
                </tr>
              </thead>
              <tbody>
                {currentLineup.map((player, index) => (
                  <tr key={player?.player_id || index}>
                    <td>
                      <div className="players_inf">
                        <div className="avtar_inf">
                          <strong className="name">{player?.player?.nm || player?.nm || "-"}</strong>
                          {player?.pos && (
                            <span className="inf">
                              {player?.goals && <strong className="count">{player?.goals}</strong>}
                              {player?.pos}
                            </span>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>{player?.ord || "-"}</td>
                    <td>{player?.sno || "-"}</td>
                    <td>{player?.mpos || player?.pos || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <NoDataFound text="No lineup data available" />
        )}
      </div>
    </div>
  );
};

export default BasketballLineup;
